import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../lib/csrf"

// The policy wizard's Content step (SMA-170). Everything goes through PolicyWizardController#update:
// - choosing a card submits the step, so it re-renders with that template's fields;
// - a field change refreshes only the document (fragment=document), so the field keeps focus;
// - Customize text copies the filled-in template into Custom, asking first when Custom has text.
export default class extends Controller {
  static targets = ["document", "updateButton", "customizeFlag", "customize", "confirm"]
  static values = { updateUrl: String, hasCustomText: Boolean }

  disconnect() {
    clearTimeout(this.timeout)
  }

  choose() {
    this.element.requestSubmit(this.updateButtonTarget)
  }

  fieldChanged() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.refreshDocument(), 300)
  }

  async refreshDocument() {
    if (!this.hasDocumentTarget) return

    const body = new FormData(this.element)
    body.set("fragment", "document")
    body.delete("customize")
    const response = await fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": csrfToken(), Accept: "text/html" },
      body
    })
    if (response.ok) this.documentTarget.innerHTML = await response.text()
  }

  customize() {
    if (!this.hasCustomTextValue) return this.replace()

    this.customizeTarget.hidden = true
    this.confirmTarget.hidden = false
  }

  replace() {
    this.customizeFlagTarget.value = "1"
    this.element.requestSubmit(this.updateButtonTarget)
  }

  keep() {
    this.confirmTarget.hidden = true
    this.customizeTarget.hidden = false
  }
}
